/* Lojas parceiras (consignação): contas puras, sem Firestore.
   Cada peça na loja tem um repasse fixo (o valor do dono) e um preço máximo
   (o preço ao cliente final). A loja escolhe o preço dela até esse máximo;
   o que passar do repasse é o lucro dela. */

export const DIAS_PARADA = 60;
// "Avisar com": o dono marca na peça (ex.: chaveiro com 1). Sem marcar, avisa quando acaba.
export const limiteAviso = item => Math.max(0, Number(item.avisarCom) || 0);

const DIA_MS = 86400000;
export const centavos = v => Math.round((Number(v) || 0) * 100) / 100;
const data = v => v?.toDate?.() || (v ? new Date(v) : null);

// 15% abaixo de R$ 40 = repasse R$ 34 (os 15% ficam com a loja)
export const repassePorDesconto = (precoMaximo, pct) => centavos((Number(precoMaximo) || 0) * (1 - (Number(pct) || 0) / 100));

export const precoDaLoja = item => Math.min(Number(item.precoVenda) || Number(item.precoMaximo) || 0, Number(item.precoMaximo) || 0);

const soma = (lista, campo) => centavos(lista.reduce((t, x) => t + (Number(x[campo]) || 0), 0));

export function resumoLoja({ itens = [], vendas = [], repasses = [] }) {
  const repasse = soma(vendas, "totalRepasse");
  const recebido = soma(repasses, "valor");
  return {
    vendido: soma(vendas, "total"),
    repasse,
    lucroLoja: soma(vendas, "lucroLoja"),
    recebido,
    saldo: centavos(repasse - recebido),
    pecas: itens.reduce((t, i) => t + (Number(i.quantidade) || 0), 0),
    valorNaLoja: centavos(itens.reduce((t, i) => t + (Number(i.quantidade) || 0) * (Number(i.repasse) || 0), 0)),
  };
}

export function vendasNoPeriodo(vendas, periodo, referencia) {
  const inicio = new Date(referencia);
  inicio.setHours(0, 0, 0, 0);
  if (periodo === "mes") inicio.setDate(1);
  if (periodo === "semana") inicio.setDate(inicio.getDate() - (inicio.getDay() + 6) % 7);
  const fim = new Date(inicio);
  if (periodo === "mes") fim.setMonth(fim.getMonth() + 1);
  else fim.setDate(fim.getDate() + (periodo === "semana" ? 7 : 1));
  return { inicio, fim, vendas: vendas.filter(v => {
    const quando = data(v.criadoEm);
    return quando && quando >= inicio && quando < fim;
  }).sort((a, b) => data(b.criadoEm) - data(a.criadoEm)) };
}

export function rankingLoja(vendas = []) {
  const porItem = {};
  for (const v of vendas) for (const it of v.itens || []) {
    const r = porItem[it.id] ||= { id: it.id, nome: it.nome, qtd: 0, valor: 0 };
    r.qtd += Number(it.qtd) || 0;
    r.valor = centavos(r.valor + (Number(it.qtd) || 0) * (Number(it.preco) || 0));
  }
  return Object.values(porItem).sort((a, b) => b.qtd - a.qtd || b.valor - a.valor);
}

// Peças paradas (sem venda há DIAS_PARADA dias desde a última venda ou desde
// que chegaram) e peças no limite do "avisar com" (ou esgotadas), com
// sugestão de reposição = o que vendeu nos últimos 30 dias (mínimo 1).
export function alertasLoja({ itens = [], vendas = [], agora = new Date() }) {
  const vendidos30 = {};
  for (const v of vendas) {
    if (agora - (data(v.criadoEm) || 0) > 30 * DIA_MS) continue;
    for (const it of v.itens || []) vendidos30[it.id] = (vendidos30[it.id] || 0) + (Number(it.qtd) || 0);
  }
  const parados = [], baixos = [];
  for (const item of itens) {
    const qtd = Number(item.quantidade) || 0;
    const desde = data(item.ultimaVendaEm) || data(item.enviadoEm);
    if (qtd > 0 && desde && agora - desde >= DIAS_PARADA * DIA_MS) parados.push({ ...item, dias: Math.floor((agora - desde) / DIA_MS) });
    if ((Number(item.vendidos) || 0) > 0 && qtd <= limiteAviso(item)) baixos.push({ ...item, sugestao: Math.max(1, vendidos30[item.id] || 0) });
  }
  return { parados, baixos };
}
